module.exports = __webpack_public_path__ + "static/media/JournalQuebec_Logo2013-.58cfe948.png";